<template>
  <ul class="tw-py-1">
    <li
      v-for="(item, index) in items"
      :key="item"
      class="tw-flex tw-items-center tw-gap-2 tw-py-1 tw-px-3 tw-border hover:tw-cursor-grab hover:tw-bg-primary-grey-100"
      :class="{
        'tw-border-dashed tw-border-primary-grey-500':
          targetItemIndex === index,
        'tw-border-white': targetItemIndex !== index,
      }"
      draggable="true"
      @dragstart="(event) => onDragStart(event, index)"
      @dragover.prevent
      @drop="onDrop(index)"
      @dragenter="onDragEnter(index)"
      @dragend="onDragEnd"
      :data-test-id="`msp-customers-data-table-column-${item}-control`"
    >
      <CbIconReorder2
        :width="18"
        :height="18"
        :data-test-id="`msp-customers-data-table-column-${item}-order-action`"
      />
      <slot :item="item" />
    </li>
  </ul>
</template>

<script lang="ts" setup>
import { ref } from "vue";

const items = defineModel<string[]>();
const draggedItemIndex = ref<null | number>(null);
const targetItemIndex = ref<null | number>(null);

const onDragStart = (event: DragEvent, item: number) => {
  if (!event.dataTransfer) {
    return;
  }
  event.dataTransfer.effectAllowed = "move";
  draggedItemIndex.value = item;
};
const moveItem = (
  array: string[],
  fromIndex: number,
  toIndex: number,
): string[] => {
  const item = array[fromIndex];
  const newArray = [
    ...array.slice(0, fromIndex),
    ...array.slice(fromIndex + 1),
  ];
  return [...newArray.slice(0, toIndex), item, ...newArray.slice(toIndex)];
};

const onDrop = (index: number) => {
  if (draggedItemIndex.value === null || !items.value) {
    return;
  }

  targetItemIndex.value = null;

  items.value = moveItem(items.value, draggedItemIndex.value, index);
};

const onDragEnter = (index: number) => {
  if (index === draggedItemIndex.value) {
    return;
  }
  targetItemIndex.value = index;
};

const onDragEnd = () => (targetItemIndex.value = null);
</script>
